export default __webpack_public_path__ + "static/media/Icon-metro-folder-download-light.7540eaad.svg";